import { media } from '@platform-ui/constants';
const {
  TABLET_S,
  TABLET_L,
  DESKTOP_S,
  DESKTOP_MD,
  DESKTOP_L,
  DESKTOP_M
} = media;
export const DEFAULT_BREAKPOINTS = {
  phone: 0,
  tabletS: TABLET_S,
  tabletL: TABLET_L,
  desktopS: DESKTOP_S,
  desktopMd: DESKTOP_MD,
  desktopM: DESKTOP_M,
  desktopL: DESKTOP_L
};